<script setup>
import { ref } from 'vue'
import ModalShowNotifications from './modal/show-notifications.vue'

const themeName = useRuntimeConfig().public.THEME_NAME
const router = useRouter()
const dyndlg = useDialog()
const notifStore = useNotificationStore()
const { userNotifications } = storeToRefs(notifStore)

const intUnreadNotifications = computed(() => userNotifications.value.filter(n => n.status === NotificationStatusEnum.UNREAD).length)
const items = ref([
  {
    label: 'Home',
    icon: 'home',
    route: '/dashboard',
  },
  {
    label: 'Published Interests',
    icon: 'inventory_2',
    route: '/published-interests',
  },
  {
    label: 'Negotiations',
    icon: 'handshake',
    route: '/negotiations',
  },
  {
    label: 'Chat',
    icon: 'chat',
    route: '/chat',
  },
  {
    label: 'Settings',
    icon: 'settings',
    route: '/settings',
  },
  {
    separator: true,
    class: 'w-full border-t border-surface-200 dark:border-surface-500',
  },
  {
    label: 'Logout',
    icon: 'logout',
    route: '/logout',
  },
])

const openNotifications = () => {
  dyndlg.open(ModalShowNotifications, {
    props: {
      style: { width: '80vw', height: '60vh' },
      modal: true,
      draggable: false,
    },
  })
}
const onNavItemClick = (route) => {
  router.push(route)
}
</script>

<template>
  <div class="card">
    <!-- //  This is wherethe change is needed the button works for the mobile version only and is not Togglingwhen insm breakpoint
    check the menu: class etc -->
    <Menubar
      :pt-options="{ mergeProps: true }"
      :pt:button="{ class: ' sm:!flex sm:!flex-auto' }"
      :pt="{ end: { class: 'flex ml-auto items-center w-full' }, item: { class: 'flex items-center' }, menu: { class: '' } }"
      :model="items"
    >
      <template #start />
      <template #item="{ item, props, hasSubmenu, root }">
        <a
          v-ripple
          class="flex items-center"
          v-bind="props.action"
          @click="() => onNavItemClick(item.route)"
        >
          <!-- <span :class="item.icon" /> -->
          <i
            class="material-symbols-outlined !block text-md lg:text-2xl"
          >{{ item.icon }}</i>
          <span class="ml-2 text-sm">{{ item.label }}</span>
          <Badge
            v-if="item.badge"
            :class="{ 'ml-auto': !root, 'ml-2': root }"
            :value="item.badge"
          />
          <span
            v-if="item.shortcut"
            class="ml-auto border border-surface-200 dark:border-surface-500 rounded-md bg-surface-100 dark:bg-surface-800 text-xs p-1"
          >{{ item.shortcut }}</span>
          <i
            v-if="hasSubmenu"
            :class="['pi pi-angle-down text-primary', { 'pi-angle-down ml-2': root, 'pi-angle-right ml-auto': !root }]"
          />
        </a>
      </template>
      <template #end>
        <div class="flex items-center gap-2 w-full">
          <img
            :src="`/${themeName}-admin-logo.svg`"
            alt="logo"
            class="flex flex-auto h-6 items-left"
          >
          <Badge
            v-if="intUnreadNotifications > 0"
            :value="intUnreadNotifications"
            :pt-options="{ mergeProps: true }"
            :pt:root="{ class: 'absolute top-0 -right-0 cursor-pointer' }"
            @click="openNotifications"
          />
          <i
            class="material-symbols-outlined !block text-2xl lg:text-2xl text-primary-700 cursor-pointer"
            @click="openNotifications"
          >notifications</i>
        </div>
      </template>
    </Menubar>
  </div>
</template>
